export const AI_CONSTANTS = {
    API_URL: 'https://generativelanguage.googleapis.com',
    MODEL: 'gemini-2.5-flash-lite',
    TEMPERATURE: 0.5,
    MAX_OUTPUT_TOKEN:200
};
